import AgGridWrapper from '@/app/common/components/ag-grid/AgGridWrapper';

import { useSearchParams } from 'react-router-dom';
import {
  domain_linkColumn,
  link_3xx_destinationColumn,
  link_alt_imgColumn,
  link_href_fragmentColumn,
  link_href_protocolColumn,
  link_href_queryColumn,
  link_href_query_countColumn,
  link_is_alternateColumn,
  link_is_authorColumn,
  link_is_bookmarkColumn,
  link_is_imgColumn,
  link_is_licenseColumn,
  link_is_nofollowColumn,
  link_is_noopenerColumn,
  link_is_noreferrerColumn,
  link_is_publisherColumn,
  link_is_sponsoredColumn,
  link_is_tagColumn,
  link_is_ugcColumn,
  link_src_imgColumn,
  link_textColumn,
  link_text_badColumn,
  ps_urlColumn,
  ps_url_depthColumn
} from '../../../config/columns';
import { useGetUserInfoQuery } from '@/app/common/api/authApi';
import { useGetInlinksMutation } from '@/app/Crawl/api/detailsApi';
import { Col, Row } from 'react-bootstrap';
import FiltersComponent from '@/app/common/components/filters/FiltersComponent';
import { decoder } from '@/helpers/utils';
import useDomain from '@/hooks/useDomain';

type ColumnDefinition = Record<string, unknown>;

const LinksAll = () => {
  const [searchParams] = useSearchParams();
  const { domain_slug } = useDomain();
  useGetUserInfoQuery();
  const [getInlinks] = useGetInlinksMutation(
    {
      job_page: searchParams.get('job_page')
    } as never
  );
  const columnGenerator = (): ColumnDefinition[] => {
    // تیین ستون های صفحات ارجاع برای لینک های داخلی و خارجی
    switch (searchParams.get('type') || 'internal') {
      case 'internal':
        return [
          ps_urlColumn({
            type: 'internal',
            details: 'links',
            activeTab: 'links'
          }),
          link_textColumn,
          domain_linkColumn,
          link_href_fragmentColumn,
          link_href_queryColumn,
          link_href_query_countColumn,
          link_href_protocolColumn,
          ps_url_depthColumn,
          link_text_badColumn,
          link_is_nofollowColumn,
          link_is_noopenerColumn,
          link_is_noreferrerColumn,
          link_is_alternateColumn,
          link_is_ugcColumn,
          link_is_tagColumn,
          link_is_sponsoredColumn,
          link_is_publisherColumn,
          link_is_licenseColumn,
          link_is_authorColumn,
          link_is_bookmarkColumn,
          link_is_imgColumn,
          link_alt_imgColumn,
          link_src_imgColumn({
            // issues: 'images_without_alt',
            details: 'assets_all',
            activeTab: 'assets_all',
            type: 'image'
          }),
          link_3xx_destinationColumn
        ];
      case 'external':
        return [
          ps_urlColumn({
            type: 'external',
            details: 'links',
            activeTab: 'links'
          }),
          link_textColumn,
          domain_linkColumn,
          link_href_fragmentColumn,
          link_href_queryColumn,
          link_href_query_countColumn,
          link_href_protocolColumn,
          ps_url_depthColumn,
          link_text_badColumn,
          link_is_nofollowColumn,
          link_is_noopenerColumn,
          link_is_noreferrerColumn,
          link_is_alternateColumn,
          link_is_ugcColumn,
          link_is_tagColumn,
          link_is_sponsoredColumn,
          link_is_publisherColumn,
          link_is_licenseColumn,
          link_is_authorColumn,
          link_is_bookmarkColumn,
          link_is_imgColumn,
          link_alt_imgColumn,
          link_src_imgColumn as unknown as ColumnDefinition,
          link_3xx_destinationColumn
        ];
      default:
        return [];
    }
  };
  return (
    <Row>
      <Col md={12}>
        <FiltersComponent
          columns={[...columnGenerator()]}
          preQueries={searchParams.toString()}
        />
      </Col>
      <Col>
        <AgGridWrapper
           
          fetchFunction={getInlinks}
          height="746px"
          columns={[...columnGenerator()]}
          additionalData={{
            job_page: searchParams.get('job_page'),
            domain_slug,
            type:
              searchParams.get('details') === 'external'
                ? 'external'
                : searchParams.get('type') || 'internal',
            page_url: decoder(searchParams.get('page_url') as string)
          }}
        />
      </Col>
    </Row>
  );
};

export default LinksAll;
